import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StateSelector from './StateSelector';
import './TabelaRSL.css';

const TabelaRSL = () => {
  const [selectedState, setSelectedState] = useState(null);
  const navigate = useNavigate();

  const handleStateSelect = (state) => {
    setSelectedState(state);
    
    // Navigate to state-specific dashboard
    if (state === 'BA') {
      navigate('/admin/tabela-RCL/ba');
    } else if (state === 'MA') {
      navigate('/admin/tabela-RCL/ma');
    } else if (state === 'PB') {
      navigate('/admin/tabela-RCL/pb');
    } else if (state === 'RS') {
      navigate('/admin/tabela-RCL/rs');
    } else if (state === 'RJ') {
      navigate('/admin/tabela-RCL/rj');
    } else if (state === 'SP') {
      navigate('/admin/tabela-RCL/sp');
    } else if (state === 'AC') {
      navigate('/admin/tabela-RCL/ac');
    } else if (state === 'AL') {
      navigate('/admin/tabela-RCL/al');
    } else if (state === 'AM') {
      navigate('/admin/tabela-RCL/am');
    } else if (state === 'AP') {
      navigate('/admin/tabela-RCL/ap');
    } else if (state === 'CE') {
      navigate('/admin/tabela-RCL/ce');
    } else if (state === 'DF') {
      navigate('/admin/tabela-RCL/df');
    } else if (state === 'ES') {
      navigate('/admin/tabela-RCL/es');
    } else if (state === 'GO') {
      navigate('/admin/tabela-RCL/go');
    } else if (state === 'MG') {
      navigate('/admin/tabela-RCL/mg');
    } else if (state === 'MS') {
      navigate('/admin/tabela-RCL/ms');
    } else if (state === 'MT') {
      navigate('/admin/tabela-RCL/mt');
    } else if (state === 'PA') {
      navigate('/admin/tabela-RCL/pa');
    } else if (state === 'PE') {
      navigate('/admin/tabela-RCL/pe');
    } else if (state === 'PI') {
      navigate('/admin/tabela-RCL/pi');
    } else if (state === 'PR') {
      navigate('/admin/tabela-RCL/pr');
    } else if (state === 'RN') {
      navigate('/admin/tabela-RCL/rn');
    } else if (state === 'RO') {
      navigate('/admin/tabela-RCL/ro');
    } else if (state === 'RR') {
      navigate('/admin/tabela-RCL/rr');
    } else if (state === 'SC') {
      navigate('/admin/tabela-RCL/sc');
    } else {
      // For other states, just log for now
      // You can add more state routes as needed
    }
  };

  return (
    <div className="tabela-RCL-container">
      <h1>Tabela RCL</h1>
      
      {!selectedState ? (
        <StateSelector onStateSelect={handleStateSelect} />
      ) : (
        <div className="selected-state-content">
          <button 
            className="back-button"
            onClick={() => setSelectedState(null)}
          >
            ← Voltar para seleção de estado
          </button>
          <h2>Estado selecionado: {selectedState}</h2>
          <p>Aqui você pode adicionar o conteúdo específico para o estado {selectedState}</p>
          {/* Add your table or content for the selected state here */}
        </div>
      )}
    </div>
  );
};

export default TabelaRSL;
